import {
  ReportDashboardComponentKind,
  ReportDashboardComponent,
  ReportDashboardMetricOptions,
  TimeBasedMetricDatePoint,
} from '@core/reports-types';
export const getComponentDatePoint = <T extends Partial<ReportDashboardComponent>>(
  component: T,
  metric: ReportDashboardMetricOptions,
  point: 'startPoint' | 'endPoint' = 'endPoint',
): TimeBasedMetricDatePoint | null => {
  if (component.kind !== ReportDashboardComponentKind.TimeBased) {
    return null;
  }
  const datePointKey = point === 'endPoint' ? component.endPoint : component.startPoint;
  const timeBasedMetric = metric.kind === ReportDashboardComponentKind.TimeBased ? metric : null;
  if (!timeBasedMetric) {
    return null;
  }
  return timeBasedMetric.datePoints?.find(datePoint => datePoint.key === datePointKey) ?? null;
};
